import PropTypes from "prop-types";
import React from "react";
import {
  ActivityIndicator,
  View,
  TouchableOpacity,
  TouchableWithoutFeedback,
  ScrollView,
} from "react-native";
import valueHelpers from "app/utils/valueHelpers";
import textHelpers from "app/utils/textHelpers";
import richTextHelpers from "app/utils/richTextHelpers";
import valueActions from "app/utils/valueActions";

import Text from "app/components/Text";
import RichText from "app/components/RichText";
import TextInput from "app/components/TextInput";
import Autocomplete from "app/components/Autocomplete";
import MultiButton from "app/components/MultiButton";
import Hoverable from "app/components/Hoverable";
import Badge from "app/components/chapter/Badge";

import { StyleContext } from "app/contexts/Style";

export default class ReferenceList extends React.Component {
  static contextType = StyleContext;
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: true,
      saving: false,
      isDirty: false,
      selectedIds: props.value.child_ids,
      values: [],
      color: valueHelpers.getColor(props.value, context.colorScheme),
    };
  }

  componentDidMount = async () => {
    this.setSuggestions();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.type != this.props.type) {
      this.setSuggestions();
    }
  }

  setSuggestions = async () => {
    this.setState({ loading: true });

    let { value, type, isDirty } = this.props;

    let values = [];

    if (type == "suggestions_to") {
      let query = value.title || value.text || "";
      values = await valueActions.autocompleteValues(query, 2, true);
    } else if (type == "suggestions_by") {
      let query = (value.title || "") + " " + (value.text || "");
      values = await valueActions.autocompleteValues(query, 2, true);
    } else if (type == "references_to") {
      let string = (value.title || "") + " " + (value.text || "");
      let referenceIds = richTextHelpers.getReferences(string);
      values = await valueActions.index(referenceIds);
    } else if (type == "referenced_by") {
      let query = `{${value.id}`;
      values = await valueActions.autocompleteValues(query, 2, true);
    }

    console.log("search res----", values);
    values = values.filter((v) => v.id != value.id);

    this.setState({ values, loading: false });
    return;

    // let suggestedValues = [];

    // for (let val of values) {
    //   let match = false;
    //   let valString = (val.title || "") + " " + (val.text || "");
    //   // let result = (string.match(new RegExp('[' + valString + ']', 'g')) || []).join('');
    //   let words = valString.split(" ").filter((w) => w?.length > 3);
    //   for (let word of words) {
    //     match = !!string.match(new RegExp("(" + word + ")", "g"))?.length;
    //     if (match) {
    //       suggestedValues.push(val);
    //       break;
    //     }
    //   }
    //   if (match) break;
    // }

    // this.setState({ values: suggestedValues, loading: false });
  };

  render() {
    let { value, type } = this.props;
    let { loading, values, selectedIds, isDirty, color, saving } = this.state;

    return (
      <View
        style={this.styles().wrapper}
        pointerEvents={saving ? "none" : "default"}
      >
        {loading ? (
          <ActivityIndicator color={color} />
        ) : !values.length ? (
          <Text>No matches found</Text>
        ) : (
          <View>
            <View style={{ flexDirection: "row", justifyContent: "flex-end" }}>
              {saving && (
                <ActivityIndicator
                  color={color}
                  style={{ marginRight: this.context.sizes.base }}
                />
              )}
              <Text button onPress={this.props.onClose}>
                Cancel
              </Text>
              <Text
                button
                selectedButton={isDirty}
                disabled={!isDirty}
                onPress={this.onSubmit}
              >
                Save
              </Text>
            </View>
            {this.renderSelectAllButton()}
            {values.map(this.renderItem)}
          </View>
        )}
      </View>
    );
  }

  renderSelectAllButton = () => {
    let { value } = this.props;
    let { values, selectedIds, color } = this.state;
    let allSelected = selectedIds.length == values.length;
    return (
      <View
        style={{
          flexDirection: "row",
          marginVertical: this.context.sizes.small,
        }}
      >
        <Text
          smallButton
          selectedButton={allSelected}
          onPress={() => {
            if (allSelected) {
              this.setState({ selectedIds: [] });
            } else {
              this.setState({
                selectedIds: values.map((v) => v.id),
                isDirty: true,
              });
            }
          }}
        >
          {allSelected ? "Deselect" : "Select"} All
        </Text>
      </View>
    );
  };

  renderItem = (value, i) => {
    let { selectedIds, color } = this.state;
    let selected = selectedIds.includes(value.id);
    return (
      <View key={i} style={this.styles().item}>
        <Badge
          // bulletOnly={!this.props.showIcon && BULLETS}
          // chapter={chapter}
          tooltipOptions
          noTooltip
          checkIcon
          iconColor={selected ? color : this.context.colors.trim}
          ringColor={this.context.colors.trim}
          ringColor={
            value.is_note ? null : selected ? color : this.context.colors.trim
          }
          backgroundColor={this.context.colors.empty}
          moment={{ value }}
          onPress={() => this.toggleSelection(value.id)}
          // large={this.props.largeBullet}
          // scale={this.props.badgeScale}
          // mobileLarge={this.props.smallBadge ? false : true}
          // loading={loading}
        />
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          <Text numberOfLines={1}>{this.highlightedText(value)}</Text>
        </ScrollView>
      </View>
    );
  };

  highlightedText = (val) => {
    let { value, type } = this.props;
    let { color } = this.state;

    let content = [];
    {
      /*content.push(<Text>{val.id}: </Text>)*/
    }
    content.push(`${val.id}: `);

    let valText = (val.title || "") + " " + (val.text || "");
    let queryArray = [];
    let textArray = [];
    if (["suggestions_to", "suggestions_by"].includes(type)) {
      queryArray = ((value.title || "") + " " + (value.text || ""))
        .split(" ")
        .filter((x) => !!x.length)
        .map((x) => x.toLowerCase());
      textArray = valText.split(" ").filter((x) => !!x.length);
    } else if (type == "references_to") {
      content.push(valText);
    } else if (type == "referenced_by") {
      // valText = richTextHelpers.injectRefernces(valText, [value, ...(value.references || [])])
      queryArray = [`${value.id}`];
      textArray = valText.split(/{([^}]+)}/);
    }

    for (let word of textArray) {
      // if (word.length > 3 && queryArray.includes(word.toLowerCase())) {
      if (
        word.length > 3 &&
        queryArray.some((q) => q.length > 3 && word.toLowerCase().includes(q))
      ) {
        let qWord = queryArray.find(
          (q) => q.length > 3 && word.toLowerCase().includes(q),
        );
        let match = word.toLowerCase().match(new RegExp(`(${qWord})`));
        if (!!match) {
          let matchIndex = word.indexOf(match[0]);
          let matchLength = match[0].length;
          content.push(word.slice(0, matchIndex));
          content.push(
            <Text style={{ backgroundColor: color }}>
              {word.slice(matchIndex, matchIndex + matchLength)}
            </Text>,
          );
          content.push(word.slice(matchIndex + matchLength));
          content.push(" ");
        } else {
          content.push(<Text style={{ backgroundColor: color }}>???? </Text>);
        }
      } else {
        content.push(word);
        content.push(" ");
      }
    }
    // {value.id}: <Text bold>{value.title}</Text> - {value.text}
    return content;
  };

  toggleSelection = (id) => {
    let { selectedIds } = this.state;
    if (selectedIds.includes(id)) {
      selectedIds.splice(selectedIds.indexOf(id), 1);
    } else {
      selectedIds.push(id);
    }
    this.setState({ selectedIds, isDirty: true });
  };

  onSubmit = async () => {
    this.setState({ saving: true });
    let { value } = this.props;
    let { selectedIds } = this.state;
    let childIds = textHelpers.uniq([...value.child_ids, ...selectedIds]);
    let success = await valueActions.update(value.id, {
      child_ids: childIds,
    });
    if (success) {
      this.props.onClose();
    } else {
      this.setState({ saving: false });
    }
  };

  styles = () => {
    return {
      wrapper: {
        padding: this.context.sizes.large,
      },
      item: {
        flexDirection: "row",
        padding: this.context.sizes.tiny,
        borderBottomWidth: 1,
        borderColor: this.context.colors.trim,
      },
    };
  };
}
